/**
 * Global DOI (depth of investigation) display settings: one mask toggle and one
 * sensitivity threshold shared by the Inversion panel (controls), the depth slice,
 * SectionView and the 3D viewer. A tiny external store (no React context) so the 2D
 * map page and the 3D page see the same value; use `useDoiSettings()` in components.
 */
import { DEFAULT_DOI_THRESHOLD } from './inversion-results';

let state = { mask: false, threshold: DEFAULT_DOI_THRESHOLD };
const listeners = new Set();

export const getDoiSettings = () => state;

export function setDoiSettings(patch) {
  const next = { ...state, ...patch };
  if (next.mask === state.mask && next.threshold === state.threshold) return;
  state = next;
  listeners.forEach((l) => l());
}

export function subscribeDoiSettings(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
